export const parseDesignSnapshot = (snapshotRaw) => {
  if (!snapshotRaw) return {};
  try {
    return typeof snapshotRaw === "string" ? JSON.parse(snapshotRaw) : snapshotRaw;
  } catch {
    return {};
  }
};

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  return text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
